import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import ImageDesktop from 'assets/illustrations/criteria-not-found-d.svg'
import ImageMobile from 'assets/illustrations/criteria-not-found-m.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const VendorsFilters = ({ onClick }) => {
  const t = useTranslation()
  const classes = useStyles()

  return (
    <Box my={3} display="flex" flexDirection="column" alignItems="center">
      <Typography variant="h2" gutterBottom className={classes.title}>
        {t('error:no-results-filter-title')}
      </Typography>
      <Box mb={2} maxWidth={440} textAlign="center">
        <Typography variant="subtitle1" color="textSecondary">
          {t('error:no-results-filter-subtitle')}
        </Typography>
      </Box>
      <Box mb={3}>
        <Button variant="contained" color="primary" onClick={onClick}>
          {t('error:no-results-filter-action')}
        </Button>
      </Box>
      <Hidden smUp>
        <img src={ImageMobile} alt="" className={classes.image} />
      </Hidden>
      <Hidden xsDown>
        <img src={ImageDesktop} alt="" className={classes.image} />
      </Hidden>
    </Box>
  )
}

export default VendorsFilters
